import script from "./LevelsTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./LevelsTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./LevelsTableLoader.vue?vue&type=style&index=0&id=ebe9f482&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebe9f482"]])

export default __exports__